<template>
  <v-container :fluid="true" class="ma-0 pa-0 bg-light-blue">
    <Infos
        v-if="$route.name === names.INFO.PAGE"
    />
    <router-view v-else />
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import Infos from "@/modules/personal_account/infos/pages/Infos.vue"
import names from "@/modules/personal_account/routers/names"

export default defineComponent({
  name: "InfosBase",
  computed: {
    names () {
      return names
    }
  },
  components: { Infos }
})
</script>

<style scoped lang="scss">

</style>
